<template>
  <div class="ProgramModuleActivity-detail-page w-100">
    <b-form @submit="handleValidate">
      <basic-subheader>
        <template v-slot:actions>
          <b-button
            class="btn btn-light ml-3"
            type="button"
            @click="returnPage"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
            </span>
            Huỷ
          </b-button>
          <b-button class="btn btn-light ml-3" type="button" @click="resetData">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
            </span>
            Reset dữ liệu
          </b-button>
          <template>
            <b-button class="btn btn-success ml-3" @click.stop="handleValidate">
              <span class="svg-icon">
                <inline-svg
                  :src="`/media/svg/icons/Neolex/Basic/${
                    isCreateForm ? 'plus' : 'save'
                  }.svg`"
                />
              </span>
              {{ isCreateForm ? 'Tạo mới' : ' Cập nhật' }}
            </b-button>
          </template>
        </template>
      </basic-subheader>
      <b-overlay :show="loading">
        <b-container
          fluid
          class="ProgramModuleActivity-list-page__body mb-6 mt-6"
        >
          <b-row>
            <b-col>
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <h5 class="card-title text-success">
                    Thông tin ProgramModuleActivity
                  </h5>
                  <b-row>
                    <!-- <b-col cols="1">
                          <template v-if="form_type === 'edit'">
                            <h5 class="mt-4">{{ form.id }}</h5>
                            <div>
                              <span>Mã số: {{ form.id }}</span>
                            </div>
                            <div class="d-flex align-items-center mt-2">
                              <span
                                class="btn btn-active"
                                style="width: 95px; cursor: default"
                                v-if="form.status === 1">
                                Active
                              </span>
                              <span
                                class="btn btn-inactive"
                                style="width: 95px; cursor: default"
                                v-if="form.status === 0">
                                Inactive
                              </span>
                              <span
                                class="btn btn-ProgramModuleActivity ml-3"
                                style="width: 95px; cursor: default">
                                Portal User
                              </span>
                            </div>
                          </template>
                    </b-col> -->
                    <b-col>
                      <b-row>
                        <b-row>
                          <b-col>
                            <basic-input
                              label="Code"
                              placeholder="Code"
                              name="code"
                              data-vv-As="Code"
                              :required="false"
                              v-validate="'required'"
                              :value.sync="form.code"
                              :state="validateState('code')"
                              :invalidFeedback="errors.first('code')"
                            ></basic-input>
                          </b-col>
                          <b-col>
                            <basic-input
                              label="IsActive"
                              placeholder="IsActive"
                              name="Trạng thái hoạt động"
                              data-vv-As="IsActive"
                              :required="true"
                              v-validate="'required'"
                              :value.sync="form.isActive"
                              :state="validateState('isActive')"
                              :invalidFeedback="errors.first('isActive')"
                            ></basic-input>
                          </b-col>
                          <b-col>
                            <basic-select
                              label="ProgramModule"
                              placeholder="--- Chọn ProgramModule ---"
                              track-by="value"
                              value-label="text"
                              :options="programModules"
                              :value.sync="form.selectedprogramModule"
                              :allow-empty="true"
                              required
                              multiple
                              name="programModule"
                              v-validate="'required'"
                              :state="validateState('programModule')"
                              :invalidFeedback="errors.first('ProgramModule')"
                              data-vv-as="programModule"
                              changeValueByObject
                              :disabled="diableInputWithPosition"
                              @update:value="resetDropdown('programModule')"
                              @input="
                                handleChangeSelect($event, 'programModule')
                              "
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <basic-select
                              label="ProgramActivity"
                              placeholder="--- Chọn ProgramActivity ---"
                              track-by="value"
                              value-label="text"
                              :options="programActivitys"
                              :value.sync="form.selectedprogramActivity"
                              :allow-empty="true"
                              required
                              multiple
                              name="programActivity"
                              v-validate="'required'"
                              :state="validateState('programActivity')"
                              :invalidFeedback="errors.first('ProgramActivity')"
                              data-vv-as="programActivity"
                              changeValueByObject
                              :disabled="diableInputWithPosition"
                              @update:value="resetDropdown('programActivity')"
                              @input="
                                handleChangeSelect($event, 'programActivity')
                              "
                            />
                          </b-col>
                          <b-col>
                            <basic-input
                              label="IsCustom"
                              placeholder="IsCustom"
                              name="isCustom"
                              data-vv-As="IsCustom"
                              :required="true"
                              v-validate="'required'"
                              :value.sync="form.isCustom"
                              :state="validateState('isCustom')"
                              :invalidFeedback="errors.first('isCustom')"
                            ></basic-input>
                          </b-col>
                          <b-col>
                            <basic-input
                              label="StartAtDay"
                              placeholder="StartAtDay"
                              name="startAtDay"
                              data-vv-As="StartAtDay"
                              :required="false"
                              v-validate="'required'"
                              :value.sync="form.startAtDay"
                              :state="validateState('startAtDay')"
                              :invalidFeedback="errors.first('startAtDay')"
                            ></basic-input>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <basic-input
                              label="Status"
                              placeholder="Status"
                              name="status"
                              data-vv-As="Status"
                              :required="true"
                              v-validate="'required'"
                              :value.sync="form.status"
                              :state="validateState('status')"
                              :invalidFeedback="errors.first('status')"
                            ></basic-input>
                          </b-col>
                        </b-row>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <div
                  class="card-footer d-flex align-items-lg-center justify-content-center"
                >
                  <b-button
                    class="btn btn-light ml-3"
                    type="button"
                    @click.stop="resetData"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                      />
                    </span>
                    Reset dữ liệu
                  </b-button>
                  <b-button
                    class="btn btn-success ml-3"
                    @click.stop="handleValidate"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/save.svg"
                      />
                    </span>
                    {{ isCreateForm ? 'Tạo mới' : 'Cập nhật' }}
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css';
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
  },
  data() {
    return {
      programActivitys: [{ id: '1', text: 'Option 1' }],
      selectedprogramActivity: 0,

      programModules: [{ id: '1', text: 'Option 1' }],
      selectedprogramModule: 0,

      form: {},
      file: null,
      preview: null,
      loading: false,
    };
  },
  created() {
    this.initDataInSelect();
    this.loadProgramModuleActivityData();
  },
  computed: {
    nationId() {
      return this.form.nation?.id;
    },
    provinceId() {
      return this.form.province?.id;
    },
    districtId() {
      return this.form.district?.id;
    },
    isCreateForm() {
      return this.form_type === 'create' || this.form_type === 'copy';
    },
  },
  methods: {
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] = value
        ? optionsArr.find((el) => el.value === value)
        : null;
      if (this.form[formProperty]) {
        this.$validator.reset({ name: formProperty });
      }
    },
    resetData() {
      this.form.code = null;
      this.form.isActive = null;
      this.form.programModuleId = null;
      this.form.programActivityId = null;
      this.form.isCustom = null;
      this.form.startAtDay = null;
      this.form.status = null;
    },
    handleChangeSelect(value, formProperty) {
      console.log('isShowError', this.isShowError);
      var newOptions = value ? value[0] : null;
      switch (formProperty) {
        case 'programActivity':
          this.selectedprogramActivity = newOptions;
          break;
        case 'programModule':
          this.selectedprogramModule = newOptions;
          break;
        default:
          break;
      }
    },

    async initDataInSelect() {
      try {
        this.loading = true;

        const [programActivityList, programModuleList] = await Promise.all([
          this.$api.get(`/programActivity`, { params: { size: 1000 } }),
          this.$api.get(`/programModule`, { params: { size: 1000 } }),
        ]);

        this.programActivitys = this.mapDataSelect(programActivityList);
        this.programModules = this.mapDataSelect(programModuleList);
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle error appropriately, e.g., show error message
      } finally {
        this.loading = false;
      }
    },
    mapDataSelect(response) {
      return response?.data.items.map((value) => {
        return {
          id: value?.id,
          text: value?.name ?? value?.description,
        };
      });
    },
    clear() {
      this.preview = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({
            name: 'program_module_activity_list',
          })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Huỷ',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      let result = await this.$validator.validateAll();
      if (!result) {
        return;
      } else {
        this.submit();
      }
    },
    async submit() {
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;
      this.form.code && payload.append('code', this.form.code);
      this.form.isActive && payload.append('isActive', this.form.isActive);
      this.form.isCustom && payload.append('isCustom', this.form.isCustom);
      this.form.startAtDay &&
        payload.append('startAtDay', this.form.startAtDay);
      this.form.status && payload.append('status', this.form.status);

      this.selectedprogramActivity &&
        payload.append('programActivityId', this.selectedprogramActivity.id);
      this.selectedprogramModule &&
        payload.append('programModuleId', this.selectedprogramModule.id);
      let confirm = await this.$swal({
        text: `${
          isCreateForm
            ? 'Bạn có chắc muốn tạo ProgramModuleActivity mới này không? '
            : 'Bạn có chắc muốn cập nhật thông tin ProgramModuleActivity này hay không?'
        }`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        if (isCreateForm) {
          this.handleCreate(payload);
        } else {
          this.handleUpdate(payload);
        }
      }
    },
    async handleCreate(payload) {
      try {
        this.loading = true;
        await this.$api.post(`ProgramModuleActivity`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, ProgramModuleActivity mới đã được tạo!',
        });
        this.$router.push({ name: 'program_module_activity_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },
    async handleUpdate(payload) {
      payload.append('id', this.form.id);
      try {
        this.loading = true;
        const id = this.form.id;
        await this.$api.put(`ProgramModuleActivity/${id}`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, ProgramModuleActivity đã được cập nhật!',
        });
        this.$router.push({ name: 'program_module_activity_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },

    async loadProgramModuleActivityData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`ProgramModuleActivity/${id}`);
        this.form = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pictureInput {
  position: relative;
}
.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}
</style>
